
// Get all option items...
const optionItems = document.querySelectorAll(".grootapps_pn-option-item");
const notifiSlideImages = document.querySelectorAll(".grootapps_pn-slide");
const notifiAccordionImages = document.querySelectorAll('.mobile_grootapps_pn-slide');
const notifiAccordionIconWrappers = document.querySelectorAll('.grootapps_pn-acoordion-icon-wrap');

function showImageForNotifiWidgets(title) {
  if (!notifiSlideImages || notifiSlideImages.length === 0) return;

  notifiSlideImages.forEach(image => {
    const slideTitle = image.dataset.slide;
    image.style.display = slideTitle === title ? 'block' : 'none';
  });
}

if (optionItems.length > 0) {
  if (window.innerWidth <= 991) {
    const firstOption = optionItems[0];
    const firstAccordionImg = notifiAccordionImages[0];
    const firstIconWrapper = notifiAccordionIconWrappers[0];
    const firstIconImg = firstIconWrapper?.querySelector('img');
    const minusImg = firstIconWrapper?.dataset.minusimg;

    firstOption.classList.add('active');
    firstAccordionImg.classList.add('active');

    if (firstIconImg && minusImg) {
      firstIconImg.src = minusImg;
    }
  } else {
    optionItems[0].classList.add("active");
    showImageForNotifiWidgets(optionItems[0].dataset.selected);
  }
}

optionItems.forEach((item, index) => {
  item.addEventListener("click", () => {
    if(window.innerWidth <= 991){
      const currentSlideImg = notifiAccordionImages[index];
      const currentSlideIconWrapper = notifiAccordionIconWrappers[index];
      const currentSlideIconImg = currentSlideIconWrapper?.querySelector('img');
      const minusImg = currentSlideIconWrapper?.dataset.minusimg;

      const isActive = item.classList.contains('active');

      // first close all..
      notifiAccordionImages.forEach((img, i) => {
        // img.style.display = 'none';
        img.classList.remove('active');
        optionItems[i].classList.remove('active');

        const iconImg = notifiAccordionIconWrappers[i]?.querySelector('img');
        const plusImg = notifiAccordionIconWrappers[i]?.dataset.plusimg;
        if (iconImg && plusImg) {
          iconImg.src = plusImg;
        }
      });

      // if it was NOT active, open it..
      if (!isActive) {
          if (currentSlideImg) currentSlideImg.classList.add('active');
          item.classList.add('active');
          if (currentSlideIconImg && minusImg) currentSlideIconImg.src = minusImg;
      }
    }else{
      const selectedId = item.getAttribute("data-selected");
      optionItems.forEach(i => i.classList.remove("active"));
      item.classList.add("active");
      showImageForNotifiWidgets(selectedId);
    }
  });
});

// On slider change add active class on option item...
// swiper.on('slideChange', () => {
//   const activeIndex = swiper.realIndex;
//   const activeSlide = swiper.slides[activeIndex];
//   const activeId = activeSlide.getAttribute('data-slide');

//   optionItems.forEach(item => {
//     if (item.getAttribute('data-selected') === activeId) {
//       item.classList.add('active');
//     } else {
//       item.classList.remove('active');
//     }
//   });
// });
